import React, { Component, Suspense } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { withRouter } from "react-router-dom";
import io from "socket.io-client";
import { Tab } from "semantic-ui-react";
import ContentWrapper from "../../../template/Layout/ContentWrapper";
// Layout components
// import Sparkline from './../../template/Common/Sparklines';
import FlotChart from "../../../template/Common/Flot";
import VectorMap from "../../../template/Maps/VectorMap";
// import { Paper } from '@material-ui/core';
import EventsTable from "./components/EventsTable";
import CardsTotals from "./components/CardTotals";
// import HorizonBar from './components/HorizontalBar';
import Chart from "react-google-charts";
import { TableLoader, FullLoader } from "./components/Loader/";
import Loader from "../../../Global/Loader";
import YearsSelect from "./components/CatYears";
import Axios from "axios";
import EasyPieChart from "easy-pie-chart";
import Map from "./../../../Components/MapsV2/map";

// Styles
import "./styles.scss";
import { Services } from "../Services";
import { TrendData, LogisticData } from "./charts.config";

const ReceiptsCards = React.lazy(() => import("./children/receipts"));
const ShipmentsCards = React.lazy(() => import("./children/shipments"));
const TruckingCards = React.lazy(() => import("./children/trucking"));

const defaultColors = {
  markerColor: "#23b7e5", // the marker points
  bgColor: "transparent", // the background
  scaleColors: ["#878c9a"], // the color of the region in the serie
  regionFill: "#bbbec6", // the base region color
};

const flotOptions = {
  legend: {
    show: false,
  },

  series: {
    lines: {
      show: false,
    },
    points: {
      show: true,
      radius: 4,
    },
    splines: {
      show: true,
      tension: 0.4,
      lineWidth: 1,
      fill: 0.5,
    },
  },
  grid: {
    borderColor: "#eee",
    borderWidth: 1,
    hoverable: true,
    backgroundColor: "#fcfcfc",
    color: "#dee1ec",
    // markings: function (axes) {
    //   var markings = [];
    //   for (var x = Math.floor(axes.xaxis.min); x < axes.xaxis.max; x += 2)
    //     markings.push({ yaxis: { from: x, to: x + 1 }, color: '#fafafa'});
    //   return markings;
    // }
  },
  tooltip: true,
  tooltipOpts: {
    content: (label, x, y) => x + " : " + y,
  },
  xaxis: {
    // show: true,
    color: "#fafafa",
    tickColor: "#fcfcfc",
    mode: "categories",
    // font: { size: 100, style: "normal", width: 300 },
    gridLines: false,
    tickDecimals: 0,
  },
  yaxis: {
    // min: 0,
    tickColor: "#eee",
    autoscaleMargin: 0.5,
    tickDecimals: 0,
    tickFormatter: (v) => v,
  },
  shadowSize: 0,
};
let orderFillment = {
  animate: {
    duration: 800,
    enabled: true,
  },
  barColor: "#23b7e5",
  trackColor: "rgba(200,200,200,0.4)",
  scaleColor: false,
  lineWidth: 10,
  lineCap: "round",
  size: 145,
};

/*=============================================
=            Dashboard Component Functions    =
=============================================*/
async function calculateSeries(data) {
  let Series = {};
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    Series[element.country] = element.value;
  }
  return Series;
}
async function calculateLogistics(data) {
  let Logistics = [
    [
      "Element",
      "Total",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
  ];
  try {
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      Logistics.push([
        element.label,
        element.value,
        element.color,
        element.extra,
      ]);
    }
    return Logistics;
  } catch (error) {
    return Logistics;
  }
}
/*=============================================
=            Dashboard Component              =
=============================================*/
class WarehousingBurgo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zoom: 1.3,
      markers: [],
      totals: {
        Bookings: "",
        Containers: "",
        CustomerId: "",
        OrderFullfillment: "",
        POs: "",
        Shipments: "",
        VendorFullfillment: "",
      },
      position: {
        lat: 4.0,
        lng: -72.0,
      },
      flotData: [],
      Attention: [],
      Logistics: [],
      Map: [],
      loadingTrends: true,
      loadingTotals: true,
      RegionValues: {},
      fullLoader: false,
    };
  }

  /*=============================================
  =            Get Info Dashboard Function      =
  =============================================*/
  getInfoDashBoard = async () => {
    let customer = this.props._customer;
    customer = parseInt(customer) ? parseInt(customer) : "";

    try {
      // ? Data for totals
      let response = await Axios.get(
        `${Services.GET_WAREHOUSING.path}warehouse/getdata/${this.props._customer}`
      );
      let total = {
        Warehouses: 0,
        Receipts: 0,
        Shipments: 0,
        Truckings: 0,
      };

      let newMarkers = [];
      let dataMap = [];

      let TotalReceipts = 0;
      let TotalShipments = 0;
      let TotalTruckings = 0;

      response.data.data.map((e, index) => {
        let obj = {
          key: `${index}`,
          title: e.Code,
          name: e.Code,
          data: e,
          position: {
            lat: Number(e.Latitude),
            lng: Number(e.Longitude),
          },
          icon: {
            url:
              "https://fsposeidon.blob.core.windows.net/poseidonpic/2923815_factory_stock_warehouse_icon_yellow (1).png",
          },
        };
        let OperacionesAduana = {
          id: e.Code,
          label: e.Name,
          value: Number(e.TotalReceipts),
        };

        let position = {
          lat: Number(e.Longitude),
          lng: Number(e.Latitude),
        };

        newMarkers.push(obj);
        dataMap.push(position);
        TotalReceipts = TotalReceipts + Number(e.TotalReceipts);
        TotalShipments = TotalShipments + Number(e.TotalShipments);
        TotalTruckings = TotalTruckings + Number(e.TotalTruckings);

        let Newtotal = {
          Truckings: TotalTruckings,
          Warehouses: response.data.data.length,
          Receipts: TotalReceipts,
          Shipments: TotalShipments,
        };
        total = Newtotal;
        return e;
      });

      this.setState({
        markers: newMarkers,
        totals: total,
        fullLoader: true,
        loadingTotals: false,
        loadingTrends: false,
      });
    } catch (error) {
      console.log("error", error);
      // this.resetTotalTrends();
      // this.setState({ flotData: TrendData, Map: [], loadingTrends: false, loadingTotals: false, Logistics: await calculateLogistics(LogisticData), fullLoader: true });
    }
  };

  onChangeYear = async (year, modulo, text) => {
    // ? flotData
    let data2 = {
      cliente: this.props._customer
        ? JSON.stringify([this.props._customer])
        : "[0]",
      year: year,
      module: modulo,
    };
    try {
      let TrendShipmentByYear = await Axios.post(
        `${Services.GET_WAREHOUSING.path}warehouse/toperacions`,
        data2
      );
      this.setState({ flotData: TrendShipmentByYear.data.data, text });
    } catch (error) {
      console.error(error);
    }
  };

  getflotChart =  () => {
    let { flotData, flotOptions } = this.state;

    let flatData = false;
    if (flotData[0]) {
      for (let i = 0; i < flotData[0].data.length; i++) {
        const e = flotData[0].data[i];
        // console.log("e", e);
        if (e[1] !== 0 || e[1] !== "0") {
          flatData = true;
        }
      }
    }
    if (!flatData) {
      return (
        <h1 style={{ textAlign: "center", marginTop: "2em" }}> No Results</h1>
      );
    } else {
      return (
        <FlotChart
          data={flotData}
          options={flotOptions}
          width={"100%"}
          height={"95%"}
        />
      );
    }
  };

  /*=============================================
  =            Life Cicle Component             =
  =============================================*/

  componentDidMount() {
    this.getInfoDashBoard();
    document.getElementById("body").className = "layout-fixed"; // !changed for nothing
  }

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      totals,
      flotData,
      Logistics,
      Attention,
      loadingTrends,
      loadingTotals,
      RegionValues,
      fullLoader,
      markers,
      position,
      zoom,
    } = this.state;
    let flatData = false;
    if (flotData[0]) {
      for (let i = 0; i < flotData[0].data.length; i++) {
        const e = flotData[0].data[i];
        // console.log("e", e);
        if (`${e[1]}` !== '0') {
          // console.log("e--->",e[1]);
          flatData = true;
        }
      }
    }
    // console.log("flatData",flatData);
    return (
      <>
        <Loader hidden={fullLoader} />
        <ContentWrapper>
          <div className="content-heading">
            <div className="row">
              <em className="fas fa-warehouse fa-1x mr-2"></em>
              Warehousing
            </div>
          </div>
          <Card>
            <CardBody>
              <Row>
                <CardsTotals
                  image={
                    <img
                      src="https://fsposeidon.blob.core.windows.net/poseidonpic/2923815-128 WHITE.png"
                      width="45"
                      height="45"
                      alt="active_po"
                    />
                  }
                  // img={}
                  xl={3}
                  md={6}
                  invertido={true}
                  loading={loadingTotals}
                  total={totals.Warehouses}
                  title={"Warehouses"}
                  // uppercase={false}
                  propertiesIcon={
                    "col-4 d-flex align-items-center bg-primary-dark justify-content-center rounded-left"
                  }
                  propertiesTitle={"col-8 py-3 bg-primary rounded-right"}
                />
                <CardsTotals
                  // image={<img src="data:image/svg+xml;base64, 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" height="45" width="45" />}
                  image={
                    <center>
                      {" "}
                      <em
                        className="fa-3x mr-2 fas fa-arrow-alt-circle-right"
                        style={{ color: "#f1f1f1" }}
                      ></em>
                    </center>
                  }
                  xl={3}
                  // uppercase={false}
                  md={6}
                  invertido={true}
                  loading={loadingTotals}
                  total={totals.Receipts}
                  title={"Receipts"}
                  propertiesIcon={
                    "col-4 d-flex align-items-center bg-purple-dark justify-content-center rounded-left"
                  }
                  propertiesTitle={"col-8 py-3  bg-purple rounded-right"}
                />
                <CardsTotals
                  image={
                    <center>
                      {" "}
                      <em
                        className="fa-3x mr-2 fas fa-arrow-alt-circle-left"
                        style={{ color: "#f1f1f1" }}
                      ></em>
                    </center>
                  }
                  xl={3}
                  md={6}
                  invertido={true}
                  // uppercase={false}
                  loading={loadingTotals}
                  total={totals.Shipments}
                  title={"Shipments"}
                  propertiesIcon={
                    "col-4 d-flex align-items-center bg-green-dark justify-content-center rounded-left"
                  }
                  propertiesTitle={"col-8 py-3 bg-green rounded-right"}
                />
                <CardsTotals
                  image={
                    <img
                      src="https://fsposeidon.blob.core.windows.net/poseidonpic/WHOTE TRUCK.png"
                      width="45"
                      height="45"
                      alt="active_containers"
                    />
                  }
                  xl={3}
                  md={6}
                  // uppercase={false}
                  loading={loadingTotals}
                  total={totals.Truckings}
                  title={"Trucking"}
                  propertiesIcon={
                    "col-4 d-flex align-items-center bg-primary-dark justify-content-center rounded-left"
                  }
                  propertiesTitle={"col-8 py-3 bg-primary rounded-right"}
                />
                <Col xl={12}>
                  <Row>
                    <Col xl={6}>
                      <div className="card myCard equalsWidth">
                        <div className="card-header">
                          <div className="card-title"> Warehouses </div>
                        </div>
                        <div className="card-body">
                          {loadingTrends ? (
                            <FullLoader />
                          ) : (
                            <div>
                              <Map
                                maxHeight="290px"
                                marker={markers}
                                visible={false}
                                heidIcon={25}
                                type={"info"}
                                position={position}
                                zoom={zoom}
                                dataDrawer={markers}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6}>
                      {/* START card */}
                      <div className="card myCard equalsWidth">
                        <div className="card-header">
                          <Col md={12}>
                            <Row>
                              <Col md={8}>
                                <div className="card-title"> Transactions </div>
                              </Col>
                              <Col md={4}>
                                <YearsSelect
                                  clients={this.props._customer}
                                  onChangeYear={this.onChangeYear}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </div>
                        <div className="card-body mx-md-n5">
                          {loadingTrends ? (
                            <FullLoader />
                          ) : !flatData ? (
                            <h1
                              style={{ textAlign: "center", marginTop: "2em" }}
                            >
                              {" "}
                              No Results
                            </h1>
                          ) : (
                            <FlotChart
                              data={flotData}
                              options={flotOptions}
                              width={"100%"}
                              height={"95%"}
                            />
                            // this.getflotChart()
                          )}
                        </div>
                      </div>
                      {/* END widget */}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div style={{ height: 40 }} />
              <Col>
                <Tab
                  menu={{ secondary: true, className: "myWrapped" }}
                  menuPosition="right"
                  panes={[
                    {
                      menuItem: "Receipts",
                      render: () => (
                        <Suspense fallback={<div>Loading...</div>}>
                          <ReceiptsCards
                            clientesSelect={this.props._customer}
                          />
                        </Suspense>
                      ),
                    },
                    {
                      menuItem: "Shipments",
                      render: () => (
                        <Suspense fallback={<div>Loading...</div>}>
                          <ShipmentsCards
                            clientesSelect={this.props._customer}
                          />
                        </Suspense>
                      ),
                    },
                    {
                      menuItem: "Trucking",
                      render: () => (
                        <Suspense fallback={<div>Loading...</div>}>
                          <TruckingCards
                            clientesSelect={this.props._customer}
                          />
                        </Suspense>
                      ),
                    },
                  ]}
                />
              </Col>
            </CardBody>
          </Card>
        </ContentWrapper>
      </>
    );
  }
}

export default withRouter(WarehousingBurgo);
